import type { StageEvent, StageOption } from 'bundles/apex/activities/types';

export function stageLabel(stage: string, stageOptions: StageOption[]): string {
  return stageOptions.find(option => option.value === stage)?.label ?? stage;
}

// whodunnit is only ever missing for data older than Apex::DealStage#set_whodunnit_id's admin-account
// fallback, and such a row reads passively rather than naming anyone.
export function stageActionText({ previousStage, whodunnit }: Pick<StageEvent, 'previousStage' | 'whodunnit'>) {
  if (previousStage) return whodunnit ? 'moved the deal from' : 'Deal moved from';

  return whodunnit ? 'created the deal in' : 'Deal was created in';
}
